import { Card } from "@jhool-io/fe-components";
import { useSearchParams } from "react-router-dom";
import PendingTasks from "../components/PendingTasks/PendingTasks";
import BillingStatCards from "../components/BillingStatCards/BillingStatCards";
import { useFetchBillingOverview } from "../hooks/dashboard.queries";
import { useDoesUserHaveRole } from "../../../hooks/permissions";
import { UserRole } from "../../../utils/types/user";
import ListState from "../../../components/ListState/ListState";
import InsuranceProviderFilter, {
    getInsuranceProviderIdsFilter,
    setInsuranceProviderIdsFilter,
} from "../../../shared-ui/InsuranceProviderFilter/InsuranceProviderFilter";

export default function BillersDashboard() {
    const isSupportGeneral = useDoesUserHaveRole([UserRole.SUPPORT_GENERAL]);

    const [searchParams, setSearchParams] = useSearchParams();

    const handleInsuranceProviderIdsChange = (
        insuranceProviderIds: string[]
    ) => {
        setInsuranceProviderIdsFilter(searchParams, insuranceProviderIds);
        searchParams.set("page", "1");
        setSearchParams(searchParams);
    };

    const insuranceProviderIdsFilter =
        getInsuranceProviderIdsFilter(searchParams);

    const { data, isLoading, error } = useFetchBillingOverview({
        insurance_provider_ids: insuranceProviderIdsFilter,
    });

    return (
        <>
            {error && error?.response?.status !== 404 && (
                <ListState
                    isError
                    stateHelperText="Try reloading this page to solve this issue"
                    errorMsg={
                        error?.response?.data.message ||
                        `Cannot display expiring policies at this time please try again later`
                    }
                />
            )}
            {!error && (
                <Card>
                    <div className="flex items-center gap-[--spacing-items] flex-wrap justify-between">
                        <div className="flex flex-col gap-y-1.5 justify-center">
                            <h2 className="text-titlefont-bold mb-1.">
                                Overview
                            </h2>
                            <p className="text-base font-normal text-textSec">
                                Manage your billing tasks and stay updated with
                                key metrics.
                            </p>
                        </div>
                        <InsuranceProviderFilter
                            values={insuranceProviderIdsFilter}
                            onChange={handleInsuranceProviderIdsChange}
                            showSelfPay={false}
                        />
                    </div>
                    <div className="mt-[--spacing-header]">
                        <BillingStatCards
                            billingStats={data}
                            isLoading={isLoading}
                        />
                    </div>
                </Card>
            )}
            {!isSupportGeneral && (
                <div className="mt-[--spacing-sections]">
                    <Card>
                        <h2 className="text-title mb-1.5">Tasks</h2>
                        <p className="text-base font-normal text-graydark">
                            You can manage your task activities here
                        </p>
                        <div className="mt-[--spacing-header]">
                            <PendingTasks />
                        </div>
                    </Card>
                </div>
            )}
        </>
    );
}
